import { AbstractControl, FormControl, FormGroup, FormsModule, ReactiveFormsModule, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { Component, effect, model, output } from '@angular/core';
import { sanitizeFields, watchFormRecursively } from '../../../shared/utils/form-utils';

import { ButtonModule } from 'primeng/button';
import { DatePickerModule } from 'primeng/datepicker';
import { FloatLabelModule } from 'primeng/floatlabel';
import { FormFieldFeedbackPipe } from '../../../pipes/form-field-feedback/form-field-feedback.pipe';
import { InputMaskModule } from 'primeng/inputmask';
import { MessageService } from 'primeng/api';
import { PasswordModule } from 'primeng/password';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { TooltipModule } from 'primeng/tooltip';
import { v4 as uuidv4 } from 'uuid';

@Component({
  selector: 'app-reset-password-form',
  imports: [
    ButtonModule,
    DatePickerModule,
    PasswordModule,
    InputMaskModule,
    FormFieldFeedbackPipe,
    TooltipModule,
    ReactiveFormsModule,
    FormsModule,
    ToggleSwitchModule,
    FloatLabelModule
  ],
  templateUrl: './reset-password-form.component.html',
  styleUrl: './reset-password-form.component.scss'
})
export class ResetPasswordFormComponent {
  readonly resetPasswordForm = new FormGroup({
    password: new FormControl<string>('', {
      validators: [
        Validators.required,
        Validators.minLength(8)
      ]
    }),
    confirmPassword: new FormControl<string>('', {
      validators: [
        Validators.required,
        Validators.minLength(8)
      ]
    })
  });

  readonly onSubmit = output<any>();
  readonly enabled = model<boolean>(true);
  readonly isLoading = model.required<boolean>();
  readonly id = uuidv4();


  readonly formWatched = watchFormRecursively(this.resetPasswordForm);

  constructor(private readonly messageService: MessageService) {
    effect(() => {
      if (this.enabled()) {
        this.resetPasswordForm.enable();
      } else {
        this.resetPasswordForm.disable();
      }
    });

    effect(() => {
        this.resetPasswordForm.get('password')?.setValidators([
          Validators.required,
          Validators.minLength(8)
        ]);
        this.resetPasswordForm.get('confirmPassword')?.setValidators([
          Validators.required,
          Validators.minLength(8)
        ]);
        this.resetPasswordForm.setValidators(this.passwordMatchValidator());

      this.resetPasswordForm.get('password')?.updateValueAndValidity({ onlySelf: true });
      this.resetPasswordForm.get('confirmPassword')?.updateValueAndValidity({ onlySelf: true });
      this.resetPasswordForm.updateValueAndValidity();
    });
  }

  resetForm(): void {
    this.resetPasswordForm.reset();
    this.isLoading.set(false);
  }

  submitForm(): void {
    this.isLoading.set(true);

    if (this.resetPasswordForm.invalid) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Atenção',
        detail: 'Preencha todos os campos corretamente!',
        life: 4000
      });

      this.isLoading.set(false);
      return;
    }

    sanitizeFields(this.resetPasswordForm);
    this.onSubmit.emit(this.resetPasswordForm.value);
  }


  private passwordMatchValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const formGroup = control as FormGroup;
      const password = formGroup.get('password');
      const confirmPassword = formGroup.get('confirmPassword');

      if (confirmPassword?.touched && confirmPassword?.value && password?.value !== confirmPassword?.value) {
        return { passwordMismatch: true };
      }

      return null;
    }
  }
}
